import {sendHashedEmailEvent} from '@optimaxdev/analytics/desktop/lib/sendHashedEmailEvent/index';
import {SagaIterator} from 'redux-saga';
import {call} from 'redux-saga/effects';

import {OAuth2Type} from 'desktop/pages/checkout/types/oAuth2Type';
import {CustomerType} from 'hostApplicationStoreType';
import {localStore} from 'libs/storage/storage';
import doTransform from 'libs/transformers/transformers';

/**
 * Send event with customer data
 * @param {string | OAuth2Type} customerData - customer data or just email
 */
export const sendEventToDataLayerForCustomerData = (customerData: string | OAuth2Type) => {
    const isOnlyEmail = typeof customerData === 'string';
    window.dataLayer?.push({
        email: isOnlyEmail ? customerData : customerData.email,
        first_name: isOnlyEmail ? '' : customerData.firstname,
        last_name: isOnlyEmail ? '' : customerData.lastname,
        MD5_email: doTransform(isOnlyEmail ? customerData : customerData.email || '', 'md5'),
        SHA256_email: doTransform(isOnlyEmail ? customerData : customerData.email || '', 'sha256'),
    });
};

/**
 * Return user email from localStorage
 * @return {string} - user email or empty string
 */
export function* getUserEmailFromStorage(): SagaIterator {
    const userEmail = yield call([localStore, 'get'], 'email', '');

    return userEmail || '';
}

/**
 * Set user data to dataLayer
 */
export function* setUserDataToDataLayer(
    emailAfterSubscription = '',
    customer: CustomerType,
): SagaIterator {
    if (emailAfterSubscription) yield call([localStore, 'set'], 'email', emailAfterSubscription);
    const userEmail = yield call(getUserEmailFromStorage);

    yield call(
        sendEventToDataLayerForCustomerData,
        customer.is_logged_in
            ? {...customer, email: emailAfterSubscription || customer.email}
            : userEmail,
    );

    yield call(sendHashedEmailEvent, customer.email);
}
